import { wrapContained as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
    h1,
      .input-config-editor{
          width:100%;
      }

    .ant-radio-button-wrapper-checked{
        .edge-image-path{
            fill:white;
        }
    }
    .editor-breadcrumb{
        color: $link;
        cursor: pointer;
        margin-bottom: 1em;
    }
  `
)
